import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { isEmpty, isNull, isUndefined } from 'lodash';
import RichTextDisplay from '../../components/RichTextDisplay';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import WorkspaceSlideHeader from './WorkspaceSlideHeader';
import PreText from './PreText';
import PostText from './PostText';
import ChooseOneSlideOptions from './ChooseOneSlideOptions';
import { RuntimeContext } from '../../../../common/RuntimeContext';

export class ChooseOneSlide extends Component {
    static propTypes = {
        canMoveToNext: PropTypes.func,
        onChange: PropTypes.func,
        responseVariableName: PropTypes.string,
        completedData: PropTypes.object,
        content: PropTypes.shape({
            options: PropTypes.array,
            description: PropTypes.string,
            displayType: PropTypes.string,
            includeChoiceLabels: PropTypes.bool,
            otherTextEnabled: PropTypes.bool
        }),
        currentUser: PropTypes.object,
        hideBookmark: PropTypes.bool,
        isRequired: PropTypes.bool,
        isUpdatingUserTrack: PropTypes.bool,
        isWelcomeWorkspace: PropTypes.bool,
        name: PropTypes.string,
        nextSectionName: PropTypes.string,
        postText: PropTypes.string,
        preText: PropTypes.string,
        setResponseVariables: PropTypes.func,
        sectionId: PropTypes.string,
        sectionItemId: PropTypes.string,
        userResponses: PropTypes.object,
        isRefSheet: PropTypes.bool,
    };

    static contextType = RuntimeContext

    constructor(props) {
        super(props);
        this.state = {
            selectChoice: props.completedData ? props.completedData.data : ''
        };
    }

    componentDidMount() {
        const {
            canMoveToNext,
            onChange,
            completedData = {},
            isRequired = false,
            sectionItemId,
            name,
            userResponses,
            content: { otherTextEnabled }
        } = this.props;

        if (userResponses && userResponses?.byParentId[sectionItemId]) {
            this.setState({ selectChoice: userResponses?.byParentId[sectionItemId].answer[0].id });
        }

        if (
            !isEmpty(completedData) &&
            typeof completedData.data === 'string' &&
            completedData.data.includes('::::') &&
            otherTextEnabled !== false
        ) {
            if (completedData.data.split('::::')[1]) {
                canMoveToNext(!isEmpty(completedData) || !isRequired);
            } else {
                canMoveToNext(!isRequired || false);
            }
        } else {
            canMoveToNext(!isEmpty(completedData) || !isRequired);
        }

        if (!isRequired && isEmpty(completedData)) {
            const isCompleted = true;

            const isAnswered = false;
            onChange(null, isCompleted, isAnswered);
        }
    }

    /**
     *
     * @param choice
     */
    handleOptionSelect = (choice, responseVariableChoice) => {
        const { onChange, isUpdatingUserTrack, canMoveToNext, setResponseVariables, responseVariableName } = this.props;
        this.setState({
            selectChoice: choice
        });
        const isCompleted = true;

        if (onChange) {
            onChange(choice, isCompleted, Boolean(choice));
        }

        if (!isNull(responseVariableChoice) && !isUndefined(responseVariableChoice) && setResponseVariables) {
            setResponseVariables(responseVariableName, responseVariableChoice);
        }

        if (!isUpdatingUserTrack) {
            canMoveToNext(true);
        }
    };

    onOtherOptionChange = (event, choice) => {
        const {
            onChange,
            isUpdatingUserTrack,
            canMoveToNext,
            content: { otherTextEnabled }
        } = this.props;
        const { value } = event.target;
        this.setState({
            selectChoice: choice
        });

        const isCompleted = true;

        if (!isUpdatingUserTrack && (!!value || otherTextEnabled === false)) {
            canMoveToNext(true);
        } else {
            canMoveToNext(false);
        }

        const isAnswered = !!value;
        if (onChange) {
            onChange(`${choice}::::${value || ''}`, isCompleted, isAnswered);
        }
    };

    render() {
        const {
            currentUser,
            name,
            nextSectionName,
            content: { displayType, options = [], description = '', includeChoiceLabels },
            sectionId,
            sectionItemId,
            hideBookmark,
            completedData,
            isWelcomeWorkspace,
            preText,
            postText,
            isRefSheet = false,
        } = this.props;
        const isImageType = displayType === 'image';
        return (
            <div className={'chooseSlide'}>
                <PreText text={preText} />
                <WorkspaceSlideHeader
                    headerText={name}
                    currentSectionItemId={sectionItemId}
                    currentSectionId={sectionId}
                    currentUser={currentUser}
                    hideBookmark={hideBookmark}
                    isRefSheet={isRefSheet}
                />
                <div className={cns('chooseSlide-options', 'playerContent')}>
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />
                    <div className={cns('options', { 'chooseSlide-options-images': isImageType })}>
                        <ChooseOneSlideOptions
                            isImageType={isImageType}
                            includeChoiceLabels={includeChoiceLabels}
                            handleOptionSelect={this.handleOptionSelect}
                            selectChoice={this.state.selectChoice}
                            options={options}
                            isWelcomeWorkspace={isWelcomeWorkspace}
                            onOtherOptionChange={this.onOtherOptionChange}
                            completedData={completedData}
                            currentUser={currentUser}
                            nextSectionName={nextSectionName}
                            displayType={displayType}
                        />
                    </div>
                </div>
                <PostText text={postText} />
            </div>
        );
    }
}

export default TrackPlayerSlideComponent(ChooseOneSlide);
